import { buildDevtoolsThemeBlock } from "../core/StringDevStyleSystem";

export function buildGridCSS(): string {
  return `
    ${buildDevtoolsThemeBlock(["[data-string-grid-root]", "[data-stdg-badge]"])}

    [data-string-grid-root],
    [data-stdg-badge] {
      --string-grid-stack-offset: 0px;
      --string-grid-panel-offset-top: 0px;
      --string-grid-trigger-gap: 8px;
      --string-grid-side-panel-gap: 8px;
    }

    [data-string-grid-overlay] {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      overflow: hidden;
    }

    [data-string-grid-list] {
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    [data-stdg-badge] > [data-stdg-panel] {
      top: var(--string-grid-panel-offset-top);
      right: calc(100% + var(--string-grid-trigger-gap));
    }

    [data-string-grid-global-hud][data-stdg-badge] {
      background: none;
      border: none;
      box-shadow: none;
      padding: 0;
      width: 0;
      min-width: 0;
      overflow: visible;
    }

    [data-string-grid-global-hud][data-stdg-badge] > [data-stdg-panel] {
      top: auto;
      bottom: 0;
      left: var(--string-grid-trigger-gap);
      right: auto;
    }

    [data-string-grid-global-hud][data-stdg-badge] [data-stdg-panel] > [data-stdg-panel] {
      top: auto;
      bottom: 0;
      left: calc(100% + var(--string-grid-side-panel-gap));
      right: auto;
    }

    

    [data-stdg-panel] > [data-stdg-panel] {
      top: 0;
      right: calc(100% + var(--string-grid-side-panel-gap));
    }

    @media (max-width: 1024px), (pointer: coarse) {
      [data-stdg-badge] > [data-stdg-panel],
      [data-string-grid-global-hud][data-stdg-badge] > [data-stdg-panel] {
        top: 0;
        right: auto;
        bottom: auto;
        left: 100%;
        margin-left: var(--string-grid-trigger-gap);
      }

      [data-stdg-panel] > [data-stdg-panel],
      [data-string-grid-global-hud][data-stdg-badge] [data-stdg-panel] > [data-stdg-panel] {
        top: calc(100% + var(--string-grid-side-panel-gap));
        right: auto;
        bottom: auto;
        left: 0;
      }
    }
  `;
}
